import { PlansRow, SubscriptionPlan } from "types";
import { env } from "@/env.mjs";

export const pricingData: SubscriptionPlan[] = [
  {
    title: "Freelancer",
    description: "Suitable for manually testing 2-3 sites in the works.",
    benefits: [
      "2,000 screenshots",
      "$0.004 per extra screenshot",
      "Unlimited comparisons",
      "3 months screenshot retention",
      "Unlimited sites",
      "Unlimited requests per minute",
      "Block ads and cookie banners",
      "Scheduled snapshots",
    ],
    limitations: [],
    prices: {
      monthly: 8,
      yearly: 80,
    },
    stripeIds: {
      monthly: env.NEXT_PUBLIC_STRIPE_STARTER_MONTHLY_PLAN_ID,
      yearly: env.NEXT_PUBLIC_STRIPE_STARTER_YEARLY_PLAN_ID,
    },
  },
  {
    title: "Agency",
    description: "Suitable for watching 3-50 sites",
    benefits: [
      "10,000 screenshots",
      "$0.004 per extra screenshot",
      "Unlimited comparisons",
      "6 months screenshot retention",
      "Unlimited sites",
      "Unlimited requests per minute",
      "Block ads and cookie banners",
      "Scheduled snapshots",
    ],
    limitations: [],
    prices: {
      monthly: 39,
      yearly: 390,
    },
    stripeIds: {
      monthly: env.NEXT_PUBLIC_STRIPE_PRO_MONTHLY_PLAN_ID,
      yearly: env.NEXT_PUBLIC_STRIPE_PRO_YEARLY_PLAN_ID,
    },
  },
  {
    title: "Hosting Provider",
    description: "Suitable for run pre and post upgrade checks on client sites.",
    benefits: [
      "50,000 screenshots",
      "$0.003 per extra screenshot",
      "Unlimited comparisons",
      "12 months screenshot retention",
      "Unlimited sites",
      "Unlimited requests per minute",
      "Block ads and cookie banners",
      "Scheduled snapshots",
      "Priority support",
    ],
    limitations: [],
    prices: {
      monthly: 149,
      yearly: 1490,
    },
    stripeIds: {
      monthly: env.NEXT_PUBLIC_STRIPE_BUSINESS_MONTHLY_PLAN_ID,
      yearly: env.NEXT_PUBLIC_STRIPE_BUSINESS_YEARLY_PLAN_ID,
    },
  },
];

export const plansColumns = [
  "starter",
  "pro",
  "business",
  "enterprise",
] as const;

export const comparePlans: PlansRow[] = [
  {
    feature: "Monthly Screenshots",
    starter: "2,000",
    pro: "10,000",
    business: "50,000",
    enterprise: "Custom",
    tooltip: "Number of screenshots you can capture per month.",
  },
  {
    feature: "Scheduled Snapshots",
    starter: "Daily",
    pro: "Hourly",
    business: "Every 15 min",
    enterprise: "Custom",
    tooltip: "Automatically capture snapshots on a recurring schedule to monitor changes.",
  },
  {
    feature: "Screenshot Retention",
    starter: "3 months",
    pro: "6 months",
    business: "12 months",
    enterprise: "Custom",
    tooltip: "How long your screenshots are stored.",
  },
  {
    feature: "Sites",
    starter: "Unlimited",
    pro: "Unlimited",
    business: "Unlimited",
    enterprise: "Unlimited",
    tooltip: "Number of different websites you can monitor.",
  },
  {
    feature: "Access to Analytics",
    starter: true,
    pro: true,
    business: true,
    enterprise: "Custom",
    tooltip: "All plans include basic analytics for tracking performance.",
  },
  {
    feature: "API Access",
    starter: "Standard",
    pro: "Standard",
    business: "Enhanced",
    enterprise: "Full",
  },
  {
    feature: "Webhooks",
    starter: true,
    pro: true,
    business: true,
    enterprise: true,
    tooltip: "Receive notifications when snapshots are completed.",
  },
  {
    feature: "Zapier, Make, and similar",
    starter: true,
    pro: true,
    business: true,
    enterprise: true,
    tooltip: "Connect with automation platforms.",
  },
  {
    feature: "Priority Support",
    starter: null,
    pro: "Email",
    business: "Email & Chat",
    enterprise: "24/7 Support",
  },
  {
    feature: "Dedicated Manager",
    starter: null,
    pro: null,
    business: null,
    enterprise: true,
    tooltip: "Enterprise plan includes a dedicated account manager.",
  },
  {
    feature: "Onboarding Assistance",
    starter: false,
    pro: "Self-service",
    business: "Assisted",
    enterprise: "Full Service",
    tooltip: "Higher plans include more comprehensive onboarding assistance.",
  },
  // Add more rows as needed
];
